import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Glossary.css';

const glossaryData = {
  Lucky: {
    title: "Lucky",
    subTitle: "Origin Feat",
    description: [
      { bold: "Luck Points.", text: "You have a number of Luck Points equal to your Proficiency Bonus and can spend the points on the benefits below. You regain your expended Luck Points when you finish a Long Rest." },
      { bold: "Advantage.", text: "When you roll a d20 for a d20 Test, you can spend 1 Luck Point to give yourself Advantage on the roll." },
      { bold: "Disadvantage.", text: "When a creature rolls a d20 for an attack roll against you, you can spend 1 Luck Point to impose Disadvantage on that roll." }
    ]
  },
  Alert: {
    title: "Alert",
    subTitle: "Origin Feat",
    description: [
      { bold: "Initiative Proficiency.", text: "When you roll Initiative, you can add your Proficiency Bonus to the roll." },
      { bold: "Initiative Swap.", text: "Immediately after you roll Initiative, you can swap your Initiative with the Initiative of one willing ally in the same combat. You can’t make this swap if you or the ally has the Incapacitated condition." }
    ]
  },
  Crafter: {
    title: "Crafter",
    subTitle: "Origin Feat",
    description: [
      { bold: "Tool Proficiency.", text: "You gain proficiency with three different Artisan’s Tools of your choice from the Fast Crafting table." },
      { bold: "Discount.", text: "Whenever you buy a nonmagical item, you receive a 20 percent discount on it." },
      { bold: "Fast Crafting.", text: "When you finish a Long Rest, you can craft one piece of gear from the Fast Crafting table, provided you have the Artisan’s Tools associated with that item and have proficiency with those tools. The item lasts until you finish another Long Rest, at which point the item falls apart." },
      { bold: "Fast Crafting Table:", text: `
        Artisan’s Tools         Crafted Gear
        Carpenter’s Tools       Ladder, Torch
        Leatherworker’s Tools   Crossbow Bolt Case, Map or Scroll Case, Pouch
        Mason’s Tools           Block and Tackle
        Potter’s Tools          Jug, Lamp
        Smith’s Tools           Ball Bearings, Bucket, Caltrops, Grappling Hook, Iron Pot
        Tinker’s Tools          Bell, Shovel, Tinderbox
        Weaver’s Tools          Basket, Rope, Net, Tent
        Woodcarver’s Tools      Club, Greatclub, Quarterstaff
      `}
    ]
  },
  Healer: {
    title: "Healer",
    subTitle: "Origin Feat",
    description: [
      { bold: "Battle Medic.", text: "If you have a Healer’s Kit, you can expend one use of it and tend to a creature within 5 feet of yourself as a Utilize action. That creature can expend one of its Hit Point Dice, and you then roll that die. The creature regains a number of Hit Points equal to the roll plus your Proficiency Bonus." },
      { bold: "Healing Rerolls.", text: "Whenever you roll a die to determine the number of Hit Points you restore with a spell or with this feat’s Battle Medic benefit, you can reroll the die if it rolls a 1, and you must use the new roll." }
    ]
  },
  MagicInitiate: {
    title: "Magic Initiate",
    subTitle: "Origin Feat",
    description: [
      { bold: "Two Cantrips.", text: "You learn two cantrips of your choice from the Cleric, Druid, or Wizard spell list. Intelligence, Wisdom, or Charisma is your spellcasting ability for this feat’s spells (choose when you select this feat)." },
      { bold: "Level 1 Spell.", text: "Choose a level 1 spell from the same list you selected for this feat’s cantrips. You always have that spell prepared. You can cast it once without a spell slot, and you regain the ability to cast it in that way when you finish a Long Rest. You can also cast the spell using any spell slots you have." },
      { bold: "Spell Change.", text: "Whenever you gain a new level, you can replace one of the spells you chose for this feat with a different spell of the same level from the chosen spell list." },
      { bold: "Repeatable.", text: "You can take this feat more than once, but you must choose a different spell list each time." }
    ]
  },
  Musician: {
    title: "Musician",
    subTitle: "Origin Feat",
    description: [
      { bold: "Instrument Training.", text: "You gain proficiency with three Musical Instruments of your choice." },
      { bold: "Encouraging Song.", text: "As you finish a Short or Long Rest, you can play a song on a Musical Instrument with which you have proficiency and give Heroic Inspiration to allies who hear the song. The number of allies you can affect in this way equals your Proficiency Bonus." }
    ]
  },
  SavageAttacker: {
    title: "Savage Attacker",
    subTitle: "Origin Feat",
    description: [
      { bold: "Savage Attack.", text: "Once per turn when you hit a target with a weapon, you can roll the weapon’s damage dice twice and use either roll against the target." }
    ]
  },
  Skilled: {
    title: "Skilled",
    subTitle: "Origin Feat",
    description: [
      { bold: "Proficiency.", text: "You gain proficiency in any combination of three skills or tools of your choice." },
      { bold: "Repeatable.", text: "You can take this feat more than once." }
    ]
  },
  TavernBrawler: {
    title: "Tavern Brawler",
    subTitle: "Origin Feat",
    description: [
      { bold: "Enhanced Unarmed Strike.", text: "When you hit with your Unarmed Strike and deal damage, you can deal Bludgeoning damage equal to 1d4 plus your Strength modifier instead of the normal damage of an Unarmed Strike." },
      { bold: "Damage Rerolls.", text: "Whenever you roll a damage die for your Unarmed Strike, you can reroll the die if it rolls a 1, and you must use the new roll." },
      { bold: "Improvised Weaponry.", text: "You have proficiency with improvised weapons." },
      { bold: "Push.", text: "When you hit a creature with an Unarmed Strike as part of the Attack action on your turn, you can deal damage to the target and also push it 5 feet away from you. You can use this benefit only once per turn." }
    ]
  },
  Tough: {
    title: "Tough",
    subTitle: "Origin Feat",
    description: [
      { bold: "Increased Hit Points.", text: "Your Hit Point maximum increases by an amount equal to twice your character level when you gain this feat. Whenever you gain a character level thereafter, your Hit Point maximum increases by an additional 2 Hit Points." }
    ]
  }
};

  

export const Glossary = ({ keyword, onClose }) => {
    const [definition, setDefinition] = useState(null);
  
    useEffect(() => {
      const foundDefinition = glossaryData[keyword];
      if (foundDefinition) {
        setDefinition(foundDefinition);
      } else {
        setDefinition(null);
      }
    }, [keyword]);
  
    if (!definition) {
      return null;
    }
  
    const modalContent = (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <button className="close-btn" onClick={onClose}>
            &times;
          </button>
          <h2>{definition.title}</h2>
          <h4>{definition.subTitle}</h4>
          <div>
            {definition.description.map((entry, index) => (
              <p key={index}>
                <strong>{entry.bold}</strong> {entry.text}
              </p>
            ))}
          </div>
        </div>
      </div>
    );
  
    return ReactDOM.createPortal(modalContent, document.body);
  };
  
